module.exports = __webpack_public_path__ + "static/media/attachment.e3901d63.svg";